import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../styles/theme';

export const SpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  overflow: hidden;
`;

const loading = keyframes`
  0% {
    transform: translateY(-100%);
  }
  50% {
    transform: translateY(0);
  }
  80% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
`;

const SvgLoader = styled.svg`
  && {
    height: 65px;
    fill: #e2e2e2;
    width: auto;
  }
  rect {
    animation: ${loading} 1.5s infinite;
    animation-fill-mode: forwards;
    will-change: transform;
  }
`;

const Loader = () => (
  <SvgLoader
    xmlns="http://www.w3.org/2000/svg"
    width="29.424"
    height="35"
    viewBox="0 0 29.424 35"
  >
    <clipPath id="somis">
      <rect height="100%" width="100%" />
    </clipPath>
    {/* eslint-disable-next-line max-len */}
    <path
      id="logo"
      d="M425.831,178.032a1.383,1.383,0,0,1,.774.236l13.014,8.723a.516.516,0,0,0,.806-.424V171.535A1.546,1.546,0,0,0,438.876,170H412.549A1.546,1.546,0,0,0,411,171.535v10.552l15.416,10.261a1.384,1.384,0,0,1,.428,1.909,1.345,1.345,0,0,1-1.125.6,1.714,1.714,0,0,1-.871-.235L411.8,185.942a.516.516,0,0,0-.8.425v7.8a3.029,3.029,0,0,0,1.253,2.148l12.392,8.364a2.243,2.243,0,0,0,2.314,0l12.33-8.364a2.9,2.9,0,0,0,1.136-2.148v-3.315l-15.373-10.305a1.37,1.37,0,0,1-.372-1.91,1.39,1.39,0,0,1,1.151-.6m-.892,6.014L428.3,186.3a1.371,1.371,0,0,1,.372,1.91,1.4,1.4,0,0,1-1.926.368l-3.363-2.253a1.37,1.37,0,0,1-.372-1.91,1.4,1.4,0,0,1,1.926-.368"
      transform="translate(-411 -170)"
    />
    <use
      clipPath="url(#somis)"
      xlinkHref="#logo"
      fill={theme.palette.primary}
    />
  </SvgLoader>
);

export default Loader;
